define([
    "underscore",
    "backbone",
    "forms/deposit/deposit_common_form"
], function(_, Backbone, SwitchPaymentForm) {
    return SwitchPaymentForm.extend({
        url: "/rest_deposit/validate_form/switch_payment",

        initialize: function() {

        },
        validation: {
            mt4_account_no: {
                required: true,
                min: 10000
            },
            currency_abbr: {
                required: true
            },
            amount: {
                required: true,
                pattern: 'number'
            },
            "card-number" : {
                required: true,
                pattern: 'number'
            },
            "expiration-month" : {
                required: true,
                pattern : 'number'
            },
            "expiration-year" : {
                required: true,
                pattern : 'number'
            },
            "cvc" : {
                required: true,
                pattern : 'number'
            }
        },
    });
});
